// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.channel_dstA6 {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.bar_e576q {
  position: absolute;
  -webkit-transition: width 0.5s;
  transition: width 0.5s;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
      -ms-flex-direction: row-reverse;
          flex-direction: row-reverse;
  overflow: hidden;
}

.bar_e576q.indeterminate__gBc0 {
  -webkit-animation: indeterminate-progress-bar-slide__fR2I 2s cubic-bezier(0.99, 0.03, 0.48, 0.75) infinite;
          animation: indeterminate-progress-bar-slide__fR2I 2s cubic-bezier(0.99, 0.03, 0.48, 0.75) infinite;
}

@-webkit-keyframes indeterminate-progress-bar-slide__fR2I {
  0% {
    left: -50%;
  }
  100% {
    left: 100%;
  }
}

@keyframes indeterminate-progress-bar-slide__fR2I {
  0% {
    left: -50%;
  }
  100% {
    left: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/ProgressBar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAAsB;EAAtB,sBAAsB;EACtB,YAAY;EACZ,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,8BAA2B;EAA3B,8BAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,0GAA4F;UAA5F,kGAA4F;AAC9F;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAPA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".channel {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n\n.bar {\n  position: absolute;\n  transition: width 0.5s;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: row-reverse;\n  overflow: hidden;\n}\n\n.bar.indeterminate {\n  animation: indeterminate-progress-bar-slide 2s cubic-bezier(0.99, 0.03, 0.48, 0.75) infinite;\n}\n\n@keyframes indeterminate-progress-bar-slide {\n  0% {\n    left: -50%;\n  }\n  100% {\n    left: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"channel": `channel_dstA6`,
	"bar": `bar_e576q`,
	"indeterminate": `indeterminate__gBc0`,
	"indeterminate-progress-bar-slide": `indeterminate-progress-bar-slide__fR2I`
};
export default ___CSS_LOADER_EXPORT___;
